import { ProjectTeamEmailMode } from 'generated/graphql';
import { TSelectOption } from '@spotted-zebra-uk/ui-components';

export const projectTeamEmailToOptionsMap = {
  [ProjectTeamEmailMode.AssigneeBased]: {
    value: ProjectTeamEmailMode.AssigneeBased,
    label: 'Assignee based',
    labelNote: `Only assignees are notified when their candidates' assessments are complete.`,
  },
  [ProjectTeamEmailMode.AccessBased]: {
    value: ProjectTeamEmailMode.AccessBased,
    label: 'Access based',
    labelNote: `All hiring team members with access to a candidate are notified when their assessments are complete.`,
  },
  [ProjectTeamEmailMode.ProjectRoleBased]: {
    value: ProjectTeamEmailMode.ProjectRoleBased,
    label: 'Hiring role based',
    labelNote: `Only specified hiring roles within the hiring team will be notified when candidates complete their assessments.`,
  },
  [ProjectTeamEmailMode.ProjectRoleAndAssigneeBased]: {
    value: ProjectTeamEmailMode.ProjectRoleAndAssigneeBased,
    label: 'Hiring role & assignee based',
    labelNote: `Only specified hiring roles within the role and all assignees will be notified when candidates complete their assessments.`,
  },
  [ProjectTeamEmailMode.Disabled]: {
    value: ProjectTeamEmailMode.Disabled,
    label: 'Disabled',
    labelNote: `No notifications will be sent when candidates complete their assessments, even if they have assignees.`,
  },
};

export const projectTeamEmailModeOptions: TSelectOption<ProjectTeamEmailMode>[] =
  [
    projectTeamEmailToOptionsMap[ProjectTeamEmailMode.AssigneeBased],
    projectTeamEmailToOptionsMap[ProjectTeamEmailMode.AccessBased],
    projectTeamEmailToOptionsMap[ProjectTeamEmailMode.ProjectRoleBased],
    projectTeamEmailToOptionsMap[
      ProjectTeamEmailMode.ProjectRoleAndAssigneeBased
    ],
    projectTeamEmailToOptionsMap[ProjectTeamEmailMode.Disabled],
  ];
